// extracted by mini-css-extract-plugin
export default {"options_content":"OptionsModal_options_content__bGr8Q","options_actions":"OptionsModal_options_actions__j6rL0","danger":"OptionsModal_danger__2zE53"};